import { connect } from 'react-redux'
import DisplayLists from '../components/DisplayLists'

const mapStateToProps = state => ({
    posts: state.posts,
    isFetchingPosts: state.isFetchingPosts
})

const ContainerDisplayLists = connect(mapStateToProps)(DisplayLists)
  
export default ContainerDisplayLists


// WEBPACK FOOTER //
// ./src/containers/ContainerDisplayLists.js